export function callWindow(name: string, ...args: unknown[]): unknown {
  const handler = (globalThis as Record<string, unknown>)[name];
  if (typeof handler !== "function") return undefined;
  return handler(...args);
}
